import LocomotiveScroll from 'locomotive-scroll'

const Scroll = {
  el: {
    body: document.querySelector<HTMLBodyElement>('#body'),
    content: document.querySelector<HTMLElement>('.content'),
    footer: document.querySelector<HTMLElement>('.footer'),
  },
  scroll: null,
  init() {
    this.scroll  = new LocomotiveScroll({
      el: this.el.body,
      offset: ['13%', '13%'],
    })
  },
}

export default Scroll
